import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { getUserName } from 'shared/helpers/users';
import { getFullDate } from 'shared/helpers/moment';
import TagList from 'shared/components/TagList/TagList';
import ShareButtons from 'desktop/components/ShareButtons/ShareButtons';
import s from './NewsInfo.css';

const isClient = process.env.BROWSER;

class NewsInfo extends React.Component {
  static propTypes = {
    post: PropTypes.shape({
      title: PropTypes.string,
      author: PropTypes.shape(),
      date: PropTypes.string,
      content: PropTypes.string,
      publication_date: PropTypes.string,
      tags: PropTypes.arrayOf(PropTypes.shape()),
      image: PropTypes.shape({
        url: PropTypes.string,
      }),
      rubric: PropTypes.shape().isRequired,
    }).isRequired,
    //
    intl: intlShape.isRequired,
  };

  render() {
    const { post, intl } = this.props;
    const {
      title,
      title_uk,
      author,
      publication_date: date,
      content,
      content_uk,
      tags,
      image,
      rubric,
    } = post;
    const { avatar } = author;
    const authorName = getUserName(author);
    const formattedDate = getFullDate(date);
    const link = isClient ? window.location.href : '';
    const isVideo = rubric.slug === 'video';
    const { locale } = intl;
    const localizedTitle = locale === 'ru' ? title || title_uk : title_uk || title;
    let localizedContent = locale === 'ru' ? content || content_uk : content_uk || content;

    const imageRe = /(<img [^>]*>)/g;
    localizedContent = localizedContent
      ? localizedContent.replace(
          imageRe,
          `<div data-hyb-ssp-in-image-overlay="5ee9e0174d506e144cfb471c" style="margin: 0 -15px;">
$1</div>`,
        )
      : '';

    return (
      <div className={s.root}>
        <div className={s.header}>
          <h1 className={s.title}>
            {localizedTitle}
          </h1>
          <div className={s.metaInfo}>
            <div className={s.authorCard}>
              {avatar && <img src={avatar} alt={authorName} className={s.avatar} />}
              <div>
                <div className={s.userName}>
                  {author && author.id && authorName}
                </div>
                <div className={s.date}>
                  {formattedDate}
                </div>
              </div>
            </div>
            <ShareButtons link={link} iconSize={35} />
          </div>
        </div>

        <div className={s.content}>
          {image &&
            image.url &&
            !isVideo &&
            <img src={image.url.replace('http:', 'https:')} alt="" className={s.mainImage} />}
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: localizedContent }}
            // eslint-disable-next-line css-modules/no-undef-class
            className={s.richText}
          />

          <div className={s.footer}>
            <ShareButtons link={link} iconSize={35} />
            {tags &&
              tags.length > 0 &&
              <TagList className={s.tags} tags={tags} currentRubric={rubric} />}
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(NewsInfo));



// WEBPACK FOOTER //
// ./src/shared/components/NewsInfo/NewsInfo.js